<app-selection-buttons-container
  [buttonsArrayBehaviorSubject]="environmentSelectionButtons"
  [title]="getEnvironmentTitle()"
  (buttonOnClick)="onEnvironmentSelected($event)"
>
</app-selection-buttons-container>
